import { Container, Nav, Navbar, NavbarText } from "reactstrap";

import Toggle from "../darkmode/ToggleButton";

function NavbarTop({ theme, toggleTheme }) {
  return (
    <div>
      <div className="bg-gradient-ucla" dark expand="md">
        <Container className="navbar">
          <img
            alt="..."
            className="mqe-logo"
            src={require("../assets/logo.png")}
          />

          <Nav className="mr-auto" navbar></Nav>

          <div className="d-flex align-items-center">
            <Toggle theme={theme} toggleTheme={toggleTheme} />
            <NavbarText>
              Forecasting <br />
              Laboratory<sub> Est. 2021</sub>
            </NavbarText>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default NavbarTop;
